<div class="bill-to formfields-padding">
  <div class="formfields" fxLayout="row wrap">
    <div class="formfields__container" fxFlex="50">
      <label i18n>Selected Party:</label>
      <mat-checkbox class="checkboxStyles"
        disabled
        [checked]="repParty ? true : false">
        {{repParty}}
      </mat-checkbox>
    </div>
  </div>
  <div class="formfields" fxLayout="row wrap">
    <div class="formfields__container" fxFlex="50">
      <mat-form-field class="bill-to__name">
        <label for="billto_name" i18n>Name</label>
        <input id="billto_name" matInput  [value]="contact" disabled />
      </mat-form-field>
      <mat-form-field class="bill-to__company">
        <label for="represented_company-billto" i18n>Company</label>
        <input id="represented_company-billto" matInput  [value]="company" disabled />
      </mat-form-field>

      <ng-container *ngIf="enableInCapacityAndCareOfNotes">
        <form [formGroup]="notesForm" novalidate>
          <iv-notes-field 
            class="note-field"
            headerNote="In Capacity Notes" i18n-headerNote 
            subheaderNote="(Appears in Invoice)" i18n-subheaderNote 
            placeHolder="Add Note Here" i18n-placeHolder
            controlName="in_capacity_notes"
            formControlName="in_capacity_notes">
          </iv-notes-field>
          <iv-notes-field
            class="note-field" 
            headerNote="Care of Notes" i18n-headerNote 
            subheaderNote="(Appears in Invoice)" i18n-subheaderNote 
            placeHolder="Add Note Here" i18n-placeHolder
            controlName="care_of_notes"
            formControlName="care_of_notes">
          </iv-notes-field>
        </form>
      </ng-container>
    </div>
    <div class="formfields__container" fxFlex="50">
      <div class="bill-to__address selected-value">
        <label for="address1" class="selected-value__label" i18n>Address</label>
        <div id="address1" class="selected-value__details address">
          <button mat-button matInput disabled>
            <div *ngIf="company && company.length > 0">
              <div class="address__name">{{company}}</div>
              <div class="address__line">{{address?.address_seq_num ? address?.address_seq_num + '. ' : '' }} {{address?.address1}}</div>
              <div class="address__line">{{address?.address2}}</div>
              <div class="address__line">{{address?.address3}}</div>
              <div class="address__line">{{address?.address4}}</div>
              <div class="address__line">
                <span>{{address?.city}}, </span>
                <span *ngIf="address?.state">{{address?.state}}, </span>
                <span>{{address?.postal}}, </span>
                <span>{{address?.country}}</span>
              </div>
              <div class="address__line" *ngIf="address?.stx_cst_rgstn && address?.stx_cst_rgstn !== ''">GSTIN: {{address?.stx_cst_rgstn}}</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
